<template>
  <div class="invoice-select">

    <div class="tile--choice" :class="classListInvoiceOnly" @click="charge.out = true, invoice.in = true">
      <fa icon="file-alt" />
      Invoice only
    </div>

    <div class="tile--choice" :class="classListChargeNow" @click="chargeNow">
      <fa icon="credit-card" />
      Charge now
      <span v-if="!organization.card">Organization has no credit card attached</span>
    </div>

    <div class="invoice-only-form" v-if="invoice.in" :class="classListInvoiceForm">
      <h1>Invoice due date</h1>
      <el-date-picker
        v-model="dueDate"
        type="date"
        placeholder="Due date">
      </el-date-picker>
      <el-button type="primary" icon="el-icon-upload" @click="$emit('select', false, dueDate)">Process</el-button>
    </div>

  </div>
</template>

<script>
export default {
  name: 'InvoiceSelect',
  props: {
    organization: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      dueDate: null,
      invoice: {
        in: false,
        out: false
      },
      charge: {
        in: false,
        out: false
      }
    }
  },
  watch: {
    organization () {
      this.canCharge = this.organization.card !== null
    }
  },
  computed: {
    canCharge () {
      return this.organization.card !== null
    },
    classListInvoiceForm () {
      return {
        'in': this.invoice.in,
      }
    },
    classListInvoiceOnly () {
      return { 
        'animate-in': this.invoice.in,
        'animate-out': this.invoice.out,
      }
    },
    classListChargeNow () {
      return {
        'disabled': !this.canCharge,
        'animate-in': this.charge.in,
        'animate-out': this.charge.out,
      }
    }
  },
  methods: {
    chargeNow () {
      if (this.organization.card) {
        this.$emit('select', true)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .invoice-select {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 300px;
  }

  .invoice-only-form {
    display: flex;
    flex-direction: column;
    position: absolute;
    opacity: 0;
    width: 300px;
    left: 0;
    right: 0;
    margin: 0 auto;

    .margin-top {
      margin-top: 20px;
    }

    h1 {
      color: $text-light;
      font-size: 14px;
      font-weight: 600;
    }

    button {
      margin-top: 20px;
    }
  }

  .in {
    animation: in .25s linear forwards;
    animation-delay: .25s;
  }

  @keyframes in {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/billing-overview/InvoiceSelect.vue